{
  "es": {
    "baseSelect": {
      "actions": {
        "fetchMore": "Cargar más"
      },
      "labels": {
        "search": "Escriba para buscar",
        "nullablePrompt": "No se seleccionó ninguna opción",
        "prompt": "Please select an Option",
        "removeTooltip": "Haga clic para eliminar la opción"
      },
      "model": {
        "baseModel": {
          "label": "Modelo base"
        }
      },
      "modelLoaner": {
        "loanerModel": {
          "label": "Modelo prestado"
        }
      },
      "modelSnubCraft": {
        "snubCraft": {
          "label": "Snub Craft",
          "prompt": "Seleccionar un Snub Craft"
        }
      },
      "modelPosition": {
        "positionType": {
          "label": "Tipo de posición",
          "prompt": "Seleccionar tipo de posición"
        },
        "source": {
          "label": "Fuente",
          "prompt": "Seleccionar fuente"
        }
      },
      "fleet": {
        "members": {
          "shipsFilter": {
            "label": "Filtro de naves",
            "prompt": "Seleccione qué naves mostrar",
            "nullablePrompt": "Seleccionar una opción"
          },
          "hangarGroupId": {
            "label": "Grupo de hangar",
            "prompt": "Seleccionar un grupo de hangar",
            "nullablePrompt": "Seleccionar un grupo"
          }
        }
      }
    }
  }
}
